import type { ReactElement } from 'react';

import classNames from 'classnames';

import { BrandIcon } from '@ui/uikit/components/common/BrandIcon';

interface TokenSymbolAppearance {
  icon?: string;
  caption?: string;
  details?: string;
}

interface TokenSymbolProps {
  ticker: string;
  note?: string;
  icon?: string | ReactElement;
  className?: string;
  appearance?: TokenSymbolAppearance;
}

const TokenSymbol = ({ ticker, note, icon, className, appearance }: TokenSymbolProps) => {
  return (
    <div className={classNames('flex flex-row gap-x-[6px]', className)}>
      {icon && (
        <div
          className={classNames(
            'token_symbol__icon row-span-2 self-center justify-self-center',
            appearance?.icon,
          )}
        >
          {typeof icon === 'string' ? <BrandIcon src={icon} /> : icon}
        </div>
      )}

      {(ticker || note) && (
        <div className={classNames('flex flex-col justify-center', appearance?.caption)}>
          {ticker && (
            <div className="font-[600] text-neutral-600 whitespace-nowrap token_symbol__label">
              {ticker}
            </div>
          )}

          {note && (
            <div
              className={classNames(
                'text-neutral-400 whitespace-nowrap token_symbol__detail',
                appearance?.details,
              )}
            >
              {note}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export { TokenSymbol };
